import { render, staticRenderFns } from "./registeredSettlement.vue?vue&type=template&id=4de9a0e8&scoped=true"
import script from "./registeredSettlement.vue?vue&type=script&lang=js"
export * from "./registeredSettlement.vue?vue&type=script&lang=js"
import style0 from "./registeredSettlement.vue?vue&type=style&index=0&id=4de9a0e8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4de9a0e8",
  null
  
)

export default component.exports